export const getCompetitionDetails = async (competitionId: number): Promise<SubscriptionCompetitionDetails> => {
  const url = new URL(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/SubscriberCompetition/GetSubscriptionCompetitionContent`
  );
  url.searchParams.append("compId", competitionId.toString());
  const response = await fetch(url.toString());
  return response.json();
};
